import { useBooleanState } from '@calendly/hooks'
import { useCallback } from 'react'

import {
  ensureFilterMenuPortalRoots,
  SchedulingFilterMenu,
} from 'components/cui_filter_menu'
import { useFilters } from 'hooks/scheduling/filters'

import { FilterModal } from './filter_modal'
import { FilterButton } from '../../shared/filters/filter_button'
import { countNonDefaultFilters } from '../../shared/filters/helpers'

export const Filter = () => {
  const { getFilterParams } = useFilters()
  const [isModalOpen, openModal, closeModal] = useBooleanState(false)
  const filterParams = getFilterParams()
  const appliedFiltersCount = countNonDefaultFilters(filterParams)

  const handleOpenChange = useCallback((nextIsOpen) => {
    if (nextIsOpen) {
      ensureFilterMenuPortalRoots()
      openModal()
    } else {
      closeModal()
    }
  }, [closeModal, openModal])

  const handleClose = useCallback(() => {
    closeModal()
  }, [closeModal])

  return (
    <SchedulingFilterMenu
      isOpen={isModalOpen}
      onOpenChange={handleOpenChange}
      onClose={handleClose}
      contentMinWidth="sul"
      responsive
      placement="bottom start"
    >
      <FilterButton appliedFiltersCount={appliedFiltersCount} />
      {isModalOpen && (
        <FilterModal onClose={handleClose} />
      )}
    </SchedulingFilterMenu>
  )
}
